import _ from 'lodash';
import { brandOverrideMetaTags } from 'helpers/HelmetHelper';
import {
  SITE_PLATFORM_MOBILE,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_WEB_LARGE,
} from 'helpers/BreakpointHelper';

export const BREAKPOINTS = {
  [SITE_PLATFORM_WEB_LARGE]: {
    actionButtonsInHeader: false,
    actionButtonsInNav: true,
    addCarouselPlaceholders: true,
    allowScrollLock: false,
    applyInlineBackground: true,
    backgroundImagePath: 'images.seriesDetail.FHD',
    brandingTitleClampSize: 0,
    carouselLimit: 5,
    posterLimit: 5,
    posterToScroll: 5,
    renderAltHeader: false,
    roundArrows: true,
    showCarouselArrows: true,
    showLogoPath: 'images.logo.raw',
    showTileMetadataOnHover: true,
    slidesToScroll: 4,
    socialLinks: true,
    subtitleLines: 2,
    tabsInAltHeader: false,
    useScrollableDiv: false,
    videoBackground: true,
  },
  [SITE_PLATFORM_WEB]: {
    actionButtonsInHeader: false,
    actionButtonsInNav: true,
    addCarouselPlaceholders: true,
    allowScrollLock: false,
    applyInlineBackground: true,
    backgroundImagePath: 'images.seriesDetail.FHD',
    brandingTitleClampSize: 0,
    carouselLimit: 5,
    descriptionLines: 5,
    posterLimit: 5,
    posterToScroll: 5,
    renderAltHeader: false,
    roundArrows: true,
    showCarouselArrows: true,
    showLogoPath: 'images.logo.raw',
    showTileMetadataOnHover: true,
    slidesToScroll: 3,
    socialLinks: true,
    subtitleLines: 2,
    tabsInAltHeader: false,
    useScrollableDiv: false,
    useSeriesLogo: true,
    videoBackground: true,
  },
  [SITE_PLATFORM_TABLET]: {
    actionButtonsInHeader: true,
    actionButtonsInNav: false,
    addCarouselPlaceholders: true,
    allowScrollLock: false,
    applyInlineBackground: true,
    backgroundImagePath: 'images.still.SD',
    brandingTitleClampSize: 4,
    carouselLimit: 3,
    descriptionLines: 5,
    posterLimit: 3,
    posterToScroll: 3,
    renderAltHeader: false,
    roundArrows: true,
    showCarouselArrows: true,
    showLogoPath: 'images.logoCenter.FHD',
    showTileMetadataOnHover: true,
    slidesToScroll: 2,
    socialLinks: false,
    subtitleLines: 2,
    tabsInAltHeader: true,
    useScrollableDiv: false,
    useSeriesLogo: true,
    videoBackground: false,
  },
  [SITE_PLATFORM_MOBILE]: {
    actionButtonsInHeader: true,
    actionButtonsInNav: false,
    addCarouselPlaceholders: false,
    allowScrollLock: false,
    applyInlineBackground: true,
    backgroundImagePath: 'images.still.SD',
    brandingTitleClampSize: 3,
    carouselLimit: 2,
    descriptionLines: 5,
    posterLimit: 3,
    posterToScroll: 3,
    renderAltHeader: false,
    roundArrows: true,
    showCarouselArrows: true,
    showLogoPath: 'images.logoCenter.raw',
    showTileMetadataOnHover: false,
    slidesToScroll: 2,
    socialLinks: false,
    subtitleLines: 2,
    tabsInAltHeader: true,
    useScrollableDiv: true,
  },
};

export function overrideMetatags({ seriesData, isPersonality }) {
  const network = _.get(seriesData, 'network');
  const brandOverride = brandOverrideMetaTags(network);
  if (brandOverride && !isPersonality) return brandOverride;
  return null;
}

export const getDropdownSeasonLabel = (items, id) => {
  const { global_seasonLabel: label } = window.Language;
  if (!items || !items.length) return label;
  const item = _.find(items, { id });
  const seasonLabel = item ? item?.name : label;
  return seasonLabel;
};
